export const warnIfDevBuild = moduleName => {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        /* eslint-disable no-console */
        console.log(
            `%c Warning: This is a Dev build of ${moduleName}`,
            'background:red; color:white; font-size:18px;'
        );
        /* eslint-enable no-console */
    }
};
